import { RiskImpact } from '../enums/riskImpact';
import { RiskLikelihoods } from 'src/app/modules/shared/enums/risks/riskLikelihoods';
import { ModifiableEntityViewModel } from 'src/app/modules/incidents/viewModels/modifiableEntityViewModel';
import { RiskRAGStatuses } from '../../shared/enums/planning/riskRagStatuses';
import { IncidentCategoryViewModel } from '../../incidents/viewModels/incidentCategoryViewModel';
import { JobCategoryViewModel } from '../../settings/viewModels/jobs/jobCategoryViewModel';
import { RAGBreakdown } from '../../shared/models/rag/ragBreakdown';

export class TemplateRiskViewModel extends ModifiableEntityViewModel {
  rag: number;
  refCode: string;
  attachmentsCount: number;
  commentsCount: number;
  impact: RiskImpact;
  likelihood: RiskLikelihoods;
  riskStrategyId?: number;
  identifiedById: number;
  created: string;
  createdById: number;
  latitude: number;
  longitude: number;
  locationDetails: string;
  headlineStatus: string;
  headlineStatusUpdated: string;
  isSelected: boolean;
  accountId: number;
  baselineRAG: RiskRAGStatuses;
  baselineLikelihood: RiskLikelihoods;
  baselineImpact: RiskImpact;
  additionalInfo: string;
  incidentsCount: number;
  incidentsBreakdown: TemplateRiskIncidentsByEventTypeViewModel[];
  jobsBreakdown: TemplateRiskJobsByEventTypeListViewModel[];
  usagePerMonth: TemplateUsagePerMonthViewModel[];
  incidentCategoryViewModels: IncidentCategoryViewModel[];
  jobCategoryViewModels: JobCategoryViewModel[];
  severityBreakdown: RAGBreakdown[];
  totalJobs: number;
  inProgressJobs: number;
  completedChecks: number;
  totalChecks: number;
  archived: boolean;
  riskAssessmentsInLast90Days: number;
  profileQuestionsCount: number;
  description: string;
  checklistsByJobCategories: TemplateRiskChecklistsByJobCategoryViewModel[];
}

export interface TemplateRiskChecklistsByJobCategoryViewModel
{
  jobCategoryId: number;
  checklists: {
    id: number;
    title: string;
    checks: any[]
  }[];
}

export class TemplateRiskIncidentsByEventTypeViewModel
{
    public id: number;
    public title: string;
    public rAGBreakdowns: RAGBreakdown[];
    public count: number;
}

export class TemplateRiskJobsByEventTypeListViewModel
{
    id: number;
    title: string
    rAGBreakdowns: RAGBreakdown[];
    percentageOfCompletion: number;
    count: number;
}

export class TemplateUsagePerMonthViewModel
{
    month: string;
    count: string;
}
